import axios from '@/http/axios';

export default {
  create: (config: any = {}) => {
    return axios.post(`/business-contacts/`, config);
  },
  update: (oid, config: any = {}) => {
    return axios.put(`/business-contacts/${oid}`, config);
  },
  delete: (oid, config: any = {}) => {
    return axios.delete(`/business-contacts/${oid}`, config);
  },
  billingContact: (oid, config: any = {}) => {
    return axios.put(`/business-contacts/${oid}/billing-contact`, config);
  },
  primaryContact: (oid, config: any = {}) => {
    return axios.put(`/business-contacts/${oid}/primary-contact`, config);
  },
  directorContact: (oid, config: any = {}) => {
    return axios.put(`/business-contacts/${oid}/director-contact`, config);
  },
  sendVerifyEmailTotp: (oid, config: any = {}) => {
    return axios.put(
      `/business-contacts/${oid}/send-verify-email-totp`,
      config
    );
  },
  verifyEmail: (oid, config: any = {}) => {
    return axios.put(`/business-contacts/${oid}/verify-email`, config);
  },
  sendVerifyMobileTotp: (oid, config: any = {}) => {
    return axios.put(
      `/business-contacts/${oid}/send-verify-mobile-totp`,
      config
    );
  },
  verifyMobile: (oid, config: any = {}) => {
    return axios.put(`/business-contacts/${oid}/verify-mobile`, config);
  },
};
